(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["steadyhound-design"] && !Shopify.designMode) return;
  try {
    (() => {
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    let cleanup = () => {};
    const start = () => {
      cleanup();
      if (!document.body.classList.contains('sh-home') || document.body.dataset.shMotion === 'false' || media.matches || window.Shopify?.designMode) return;
      const controller = new AbortController();
      const running = new Set();
      const play = (element, frames, options) => {
        if (!element.animate) return;
        const animation = element.animate(frames, options);
        running.add(animation);
        animation.finished.catch(() => {}).finally(() => running.delete(animation));
      };
      document.querySelectorAll('.sh-hero__content > *').forEach((element, i) => play(element, [{opacity: 0, transform: 'translateY(20px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 750, delay: i * 100, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards'}));
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const element = entry.target;
            play(element, [{opacity: .15, transform: 'translateY(24px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 850, easing: 'cubic-bezier(.2,.7,.2,1)'});
            observer.unobserve(element);
          });
        }, {threshold: .12});
        document.querySelectorAll('.shb__panel > *, .shs__row, .sh-trial__content > *, .shopify-section--rich-text .prose, .newsletter-content > *').forEach(element => observer.observe(element));
      }
      const hero = document.querySelector('.sh-hero');
      const frame = hero?.querySelector('.sh-hero__image');
      let scheduled = 0;
      const update = () => {
        scheduled = 0;
        if (!hero || !frame) return;
        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        const progress = Math.max(0, Math.min(1, -rect.top / rect.height));
        frame.style.transform = `scale(${1 + progress * .055}) translateY(${progress * 14}px)`;
      };
      if (hero && frame && hero.dataset.parallax === 'true') {
        addEventListener('scroll', () => { if (!scheduled) scheduled = requestAnimationFrame(update); }, {passive: true, signal: controller.signal});
        update();
      }
      cleanup = () => {
        controller.abort();
        observer?.disconnect();
        cancelAnimationFrame(scheduled);
        running.forEach(animation => animation.cancel());
        frame?.style.removeProperty('transform');
      };
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
    document.addEventListener('shopify:section:load', start);
    document.addEventListener('shopify:section:unload', start);
    media.addEventListener('change', start);
    addEventListener('pagehide', () => cleanup());
    addEventListener('pageshow', event => { if (event.persisted) start(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
